export const USE_CASES = [
  {
    spot: "1",
    title: "Client applies for credit",
    description: `A person applies for personal loan in a bank branch and signs
    the application digitally on a signature pad. The individual's motion data
    is stored in the system according to GDPR.`,
  },
  {
    spot: "2",
    title: "Extracting data from e-signature",
    description: `Extracting data from signature that supports more accurate risk
    predictions such as: people with lower levels of education are more likely
    to push the pen harder when signing their signature and people with lower
    levels of education are less likely to repay their loans in general.`,
  },
  {
    spot: "3",
    title: "Risk assessment with new metrics",
    description: `The credit risk specialist combines the usual credit risk
    default model with our additional, state-of-the-art metrics to reach the
    most accurate prediction and minimize the cost of default for the financial
    institution.`,
  },
];

export default USE_CASES;
